import Vue from 'vue'
import VueRouter from 'vue-router'
import Index from '../views/index.vue'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Index',
    component: Index
  },
  {
    path: '/team',
    name: 'team',
    component: () => import('../views/team.vue')
  },
  {
    path: '/teaminner',
    component: () => import('../views/teamInner.vue')
  },
  {
    path: '/jiankang',
    name: 'jiankang',
    component: () => import('../views/jiankang.vue')
  },
  {
    path: '/jiankanginner',
    name: 'jiankanginner',
    component: () => import('../views/jiankangInner.vue')
  },
  {
    path: '/xu',
    name: 'xu',
    component: () => import('../views/xu.vue')
  },
  {
    path: '/xuinner',
    name: 'xuinner',
    component: () => import('../views/xuInner.vue')
  },
  {
    path: '/job',
    name: 'job',
    component: () => import('../views/job.vue')
  },
  {
    path: '/jobInner',
    name: 'jobInner',
    component: () => import('../views/jobInner.vue')
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
